export default __webpack_public_path__ + "static/media/chevron-left.ddbe22c0.svg";